/* REYKON bulk quote list — stored in the visitor's browser, separate from the Shopify cart. */
(function () {
  'use strict';
  if (window.__rkqLoaded) return;
  window.__rkqLoaded = true;
  var KEY = 'rkq_v1';
  var MOQ = 500;

  function load() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var data = raw ? JSON.parse(raw) : null;
      if (data && Array.isArray(data.items)) return data;
    } catch (e) {}
    return { items: [] };
  }
  function save(data) {
    try { window.localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
    updatePill(data);
  }
  function clearList() { save({ items: [] }); }

  function money(cents, currency) {
    var v = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(v);
    } catch (e) {
      return (currency || 'USD') + ' ' + v.toFixed(2);
    }
  }
  function clampQty(v) {
    var n = parseInt(String(v).replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? MOQ : n;
  }
  function countItems(data) { return data.items.length; }

  function updatePill(data) {
    data = data || load();
    var n = countItems(data);
    document.querySelectorAll('[data-rkq-count]').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- Product page module ---------- */
  function initProduct(root) {
    var currency = root.getAttribute('data-currency') || 'USD';
    var variantEl = root.querySelector('[data-rkq-variant]');
    var qtyEl = root.querySelector('[data-rkq-qty]');
    var unitEl = root.querySelector('[data-rkq-unit]');
    var totalEl = root.querySelector('[data-rkq-total]');
    var errEl = root.querySelector('[data-rkq-error]');
    var addBtn = root.querySelector('[data-rkq-add]');
    var doneEl = root.querySelector('[data-rkq-done]');
    var doneText = root.querySelector('[data-rkq-done-text]');

    function current() {
      var opt = variantEl.tagName === 'SELECT' ? variantEl.options[variantEl.selectedIndex] : variantEl;
      return {
        id: String(variantEl.value),
        price: Number(opt.getAttribute('data-price')) || 0,
        title: opt.getAttribute('data-title') || ''
      };
    }
    function refresh() {
      var v = current();
      var q = clampQty(qtyEl.value);
      var ok = q >= MOQ;
      unitEl.textContent = money(v.price, currency);
      totalEl.textContent = ok ? money(v.price * q, currency) : '—';
      errEl.hidden = ok;
      qtyEl.setAttribute('aria-invalid', ok ? 'false' : 'true');
      return ok;
    }

    root.querySelectorAll('[data-rkq-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = clampQty(qtyEl.value) + Number(b.getAttribute('data-rkq-step'));
        qtyEl.value = Math.max(MOQ, q);
        refresh();
      });
    });
    qtyEl.addEventListener('input', refresh);
    qtyEl.addEventListener('blur', function () {
      if (clampQty(qtyEl.value) < MOQ) qtyEl.value = MOQ;
      refresh();
    });
    if (variantEl.tagName === 'SELECT') variantEl.addEventListener('change', refresh);

    addBtn.addEventListener('click', function () {
      if (!refresh()) { qtyEl.focus(); return; }
      var v = current();
      var q = clampQty(qtyEl.value);
      var data = load();
      var existing = data.items.filter(function (it) { return it.variantId === v.id; })[0];
      if (existing) {
        existing.qty = existing.qty + q;
        existing.price = v.price;
      } else {
        data.items.push({
          variantId: v.id,
          productId: root.getAttribute('data-product-id'),
          title: root.getAttribute('data-product-title'),
          variantTitle: v.title,
          url: root.getAttribute('data-product-url'),
          image: root.getAttribute('data-product-image'),
          price: v.price,
          qty: q
        });
      }
      data.currency = currency;
      save(data);
      doneText.textContent = existing
        ? 'Updated — now ' + existing.qty.toLocaleString('en-US') + ' units in your quote list.'
        : q.toLocaleString('en-US') + ' units added to your quote list.';
      doneEl.hidden = false;
      addBtn.textContent = 'Add more to Bulk Quote';
    });

    var back = root.querySelector('[data-rkq-back]');
    try {
      var ref = document.referrer ? new URL(document.referrer) : null;
      if (back && ref && ref.origin === location.origin && /^\/collections\/[^/]+\/?$/.test(ref.pathname)) {
        back.href = ref.pathname + ref.search;
      }
    } catch (e) {}

    refresh();
  }

  /* ---------- Header cart menu ---------- */
  function initCartMenu(wrap) {
    var trigger = wrap.querySelector('#cart-icon-bubble');
    var panel = wrap.querySelector('[data-rkq-cartmenu-panel]');
    if (!trigger || !panel) return;
    var openedBy = null;
    var closeTimer = null;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function refreshCounts() {
      updatePill();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          panel.querySelectorAll('[data-rkq-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
        })
        .catch(function () {});
    }
    function open(by) {
      clearTimeout(closeTimer);
      if (!panel.hidden) { if (by === 'click') openedBy = 'click'; return; }
      panel.hidden = false;
      openedBy = by;
      trigger.setAttribute('aria-expanded', 'true');
      refreshCounts();
    }
    function close() {
      clearTimeout(closeTimer);
      panel.hidden = true;
      openedBy = null;
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (panel.hidden) { open('click'); return; }
      if (openedBy === 'hover') { openedBy = 'click'; return; }
      close();
    }, true);

    if (canHover) {
      wrap.addEventListener('mouseenter', function () { open('hover'); });
      wrap.addEventListener('mouseleave', function () {
        if (openedBy !== 'hover') return;
        closeTimer = setTimeout(close, 180);
      });
    }
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { close(); trigger.focus(); }
    });
    wrap.addEventListener('focusout', function (e) {
      if (!panel.hidden && e.relatedTarget && !wrap.contains(e.relatedTarget)) close();
    });
  }

  /* ---------- Quote page ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initPage(page) {
    var listWrap = page.querySelector('[data-rkq-list]');
    var form = document.getElementById('RkqForm');
    var itemsField = page.querySelector('[data-rkq-items-field]');
    var totalField = page.querySelector('[data-rkq-total-field]');

    var posted = page.querySelector('[data-rkq-posted]');
    if (posted && posted.getAttribute('data-rkq-posted') === 'true') clearList();

    function render() {
      var data = load();
      var cur = data.currency || 'USD';
      if (!data.items.length) {
        listWrap.innerHTML =
          '<div class="rkq-empty"><p>Your quote list is empty. Browse products and choose <strong>Add to Bulk Quote</strong> — or just describe what you need in the form below.</p>' +
          '<a class="rkq__btn" href="/collections/all">Browse products</a></div>';
        sync(data);
        return;
      }
      var subtotal = 0;
      var rows = data.items.map(function (it, i) {
        var line = it.price * it.qty;
        subtotal += line;
        var bad = it.qty < MOQ;
        return '<div class="rkq-row" data-i="' + i + '">' +
          (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy" width="64" height="64">' : '<span></span>') +
          '<div class="rkq-row__name"><a href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
            '<small>' + (it.variantTitle ? esc(it.variantTitle) + ' · ' : '') + money(it.price, cur) + ' / unit</small></div>' +
          '<div class="rkq__qty"><button type="button" class="rkq__step" data-act="dec" aria-label="Decrease by 100">−</button>' +
            '<input class="rkq__qty-input" type="number" inputmode="numeric" min="500" value="' + it.qty + '" data-act="qty" aria-label="Quantity for ' + esc(it.title) + '">' +
            '<button type="button" class="rkq__step" data-act="inc" aria-label="Increase by 100">+</button></div>' +
          '<div class="rkq-row__total">' + money(line, cur) + '</div>' +
          '<button type="button" class="rkq-row__remove" data-act="rm" aria-label="Remove ' + esc(it.title) + '">×</button>' +
          (bad ? '<p class="rkq-row__err">Minimum order is 500 units.</p>' : '') +
        '</div>';
      }).join('');
      listWrap.innerHTML =
        '<div class="rkq-list">' + rows + '</div>' +
        '<div class="rkq-sum"><span>Estimated product subtotal (' + data.items.length + (data.items.length === 1 ? ' product' : ' products') + ')</span><strong>' + money(subtotal, cur) + '</strong></div>' +
        '<p class="rkq-sum__note">Product prices only. Shipping, import duties and taxes are quoted separately once we know your destination.</p>';
      sync(data, subtotal);
    }

    function sync(data, subtotal) {
      var cur = data.currency || 'USD';
      var lines = data.items.map(function (it, i) {
        return (i + 1) + '. ' + it.title + (it.variantTitle ? ' [' + it.variantTitle + ']' : '') +
          ' — ' + it.qty + ' units × ' + money(it.price, cur) + ' = ' + money(it.price * it.qty, cur) +
          ' (variant ' + it.variantId + ')';
      });
      if (itemsField) itemsField.value = lines.length ? lines.join('\n') : 'No products selected — see message.';
      if (totalField) totalField.value = lines.length ? money(subtotal || 0, cur) + ' (excl. shipping & duties)' : 'n/a';
      updatePill(data);
    }

    listWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-act]');
      if (!btn || btn.tagName === 'INPUT') return;
      var row = btn.closest('.rkq-row');
      var i = Number(row.getAttribute('data-i'));
      var data = load();
      var it = data.items[i];
      if (!it) return;
      var act = btn.getAttribute('data-act');
      if (act === 'rm') data.items.splice(i, 1);
      if (act === 'inc') it.qty += 100;
      if (act === 'dec') it.qty = Math.max(MOQ, it.qty - 100);
      save(data);
      render();
    });
    listWrap.addEventListener('change', function (e) {
      if (e.target.getAttribute('data-act') !== 'qty') return;
      var row = e.target.closest('.rkq-row');
      var data = load();
      var it = data.items[Number(row.getAttribute('data-i'))];
      if (!it) return;
      it.qty = Math.max(MOQ, clampQty(e.target.value));
      save(data);
      render();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        var data = load();
        var msg = document.getElementById('RkqForm-body');
        if (!data.items.length && msg && !msg.value.trim()) {
          e.preventDefault();
          msg.setCustomValidity('Add products to your quote list, or tell us what you need here.');
          msg.reportValidity();
          return;
        }
        if (msg) msg.setCustomValidity('');
        sync(data, data.items.reduce(function (s, it) { return s + it.price * it.qty; }, 0));
      });
      var msgEl = document.getElementById('RkqForm-body');
      if (msgEl) msgEl.addEventListener('input', function () { msgEl.setCustomValidity(''); });
    }

    render();
  }

  function init() {
    // The WhatsApp button is rendered inside the header; move it to <body> so the
    // header's scroll transforms can't affect its fixed position.
    var wa = document.querySelector('.rkw');
    if (wa && wa.parentElement !== document.body) document.body.appendChild(wa);
    document.querySelectorAll('[data-rkq-product]').forEach(initProduct);
    document.querySelectorAll('[data-rkq-cartmenu]').forEach(initCartMenu);
    var page = document.getElementById('rkq-page');
    if (page) initPage(page);
    updatePill();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('storage', function (e) { if (e.key === KEY) updatePill(); });
})();
